// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AdminType } from './admin-type';
import { Asset } from './asset';
import { Bankrupt } from './bankrupt';
import { Document } from './document';
import { Period } from './period';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountValue extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountValueId!: number;
  accountId!: number;
  adminTypeId?: number;
  asAtDate?: Date;
  assetId?: number;
  bankruptId?: number;
  createdBy!: string;
  createdDate!: Date;
  documentId?: number;
  flags!: number;
  periodId?: number;
  revision?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  value!: number;
  value1!: number;
  value2!: number;
  valueTypeId!: number;
  account!: Account;
  adminType!: AdminType;
  asset!: Asset;
  bankrupt!: Bankrupt;
  document!: Document;
  period!: Period;
}

